var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidden({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.291,
    viewBox: "0 0 20 16.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-hide-5783163",
    d: "M283.82,342.731a9.87,9.87,0,0,0-4.442-1.012c-4.284,0-7.375,2.416-9.877,6.25l-.054.1-.005.012a.764.764,0,0,0,0,.61l.059.11a15.807,15.807,0,0,0,4.146,4.48l-1.917,1.988a.761.761,0,0,0,0,1.047.7.7,0,0,0,1.01,0l2.2-2.276a9.868,9.868,0,0,0,4.442,1.012c4.284,0,7.375-2.416,9.877-6.25a.762.762,0,0,0,0-.829,15.8,15.8,0,0,0-4.146-4.48l1.917-1.987a.76.76,0,0,0,0-1.047.7.7,0,0,0-1.01,0Zm.251,1.834-1.2,1.244a4.531,4.531,0,0,1,.793,2.574,4.369,4.369,0,0,1-4.286,4.443,4.162,4.162,0,0,1-2.483-.822l-.871.9a8.558,8.558,0,0,0,3.354.658c3.633,0,6.256-2.028,8.417-5.184a13.44,13.44,0,0,0-3.723-3.818Zm-1.339-.707a8.559,8.559,0,0,0-3.354-.658c-3.633,0-6.256,2.028-8.416,5.184a13.446,13.446,0,0,0,3.723,3.818l1.2-1.244a4.532,4.532,0,0,1-.793-2.574,4.369,4.369,0,0,1,4.286-4.443,4.162,4.162,0,0,1,2.483.822Zm-.893,3.021a3.033,3.033,0,0,1,.4,1.5,2.912,2.912,0,0,1-2.857,2.962,2.769,2.769,0,0,1-1.451-.41Zm-1.01-1.047-3.913,4.057a3.033,3.033,0,0,1-.4-1.5,2.912,2.912,0,0,1,2.857-2.962,2.77,2.77,0,0,1,1.451.41Z",
    transform: "translate(-269.377 -340.238)",
    fill: "rgba(110,110,115,0.64)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.15fa5fe78446c301794608a5bba7f84f.svg";
export { ForwardRef as ReactComponent };